import React from 'react';
import AppLayout from '../components/ui/AppLayout';
import PageHeader from '../components/ui/PageHeader';
import SectionCard from '../components/ui/SectionCard';
import Prose from '../components/ui/Prose';
import Regras from '../components/regras';

const Estatuto = () => (
  <AppLayout maxWidth="md">
    <PageHeader eyebrow="Riviera FC" title="Regras da pelada" subtitle="Check-in, ordem de chegada, formação e rodízio dos times, avaliação e as regras de jogo." />
    <SectionCard>
      <Prose><Regras /></Prose>
    </SectionCard>
  </AppLayout>
);

export default Estatuto;
